import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { List, ListItem, ListItemIcon, ListItemText, withStyles, Tooltip, Divider } from '@material-ui/core';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { WithStyles } from '@material-ui/core/styles';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  isExpanded: boolean;
  signOut: () => Promise<void>;
}

const SettingsMenu = ({ classes, history, isExpanded, signOut }: Props): React.ReactElement => {
  const handleSignOut = async () => {
    await signOut();
    history.replace('/sign-in');
  };

  return (
    <div className={classes.root}>
      <Divider className={classes.listDivider} />
      <List className={classes.list} component="div" disablePadding>
        <ListItem onClick={handleSignOut} className={classes.listItem} button>
          {isExpanded ? (
            <>
              <ListItemIcon className={classes.listItemIcon}>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText className={classes.listItemText} classes={{ primary: classes.listItemText }} primary="Sign out" />
            </>
          ) : (
            <Tooltip title="Sign out" placement="right">
              <ListItemIcon className={classes.listItemIcon}>
                <ExitToAppIcon />
              </ListItemIcon>
            </Tooltip>
          )}
        </ListItem>
      </List>
    </div>
  );
};

export default withRouter(withStyles(styles)(SettingsMenu));
